import { API } from "../services/api/types";
import { randomNumber } from "./number";

export const getRandomCampaign = (campaigns: API.Campaign[]) => {
  const totalWeight = campaigns.reduce(
    (sum, campaign) => sum + (campaign.priority ?? 1),
    0
  );

  let random = Math.random() * totalWeight;

  for (const campaign of campaigns) {
    const weight = campaign.priority ?? 1;
    if (random < weight) {
      return campaign;
    }
    random -= weight;
  }

  return campaigns[randomNumber(0, campaigns.length - 1)];
};

export const getClubCampaignId = (clubId: number) => {
  switch (clubId) {
    // AIK
    case 4:
      return 12;
    // Hammarby
    case 9:
      return 13;
  }
};

export const getCampaignClubId = (campaignId: number) => {
  switch (campaignId) {
    // AIK
    case 12:
      return 4;
    // Hammarby
    case 13:
      return 9;
  }
};
